<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100,
    }
  }
}
</script>

<template>
  <modal
    :adaptive="true" height="auto" width="418"
    name="file-uploading" class="file-uploading-progress"
    :clickToClose="false"
  >
    <div class="file-uploading-progress-content">
      <div class="bold">Uploading your file</div>
      <div class="gap-1x" />
      <div>
        <b-progress :value="progress" :max="max" />
      </div>
    </div>
  </modal>
</template>

<style lang="scss">
.file-uploading-progress {
  .file-uploading-progress-content {
    padding: 24px;
  }

  .progress {
    width: 368px;
    background: #C5C5C5;
    border-radius: 0;

    .progress-bar {
      background: #6D6D6D;
    }
  }
}
</style>
